export default __webpack_public_path__ + "static/media/Thomas Penninger.4df4023a.png";